import { defineAsyncComponent } from 'vue'
export default {
  "components-footer": defineAsyncComponent(() => import("/var/www/frontend/reviewapp-production/layouts/components/Footer.vue").then(m => m.default || m)),
  "components-navbar": defineAsyncComponent(() => import("/var/www/frontend/reviewapp-production/layouts/components/Navbar.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/var/www/frontend/reviewapp-production/layouts/default.vue").then(m => m.default || m))
}